import EventAgent from '@hotmart-org-ca/event-agent-js'
import * as types from 'store/mutation-types'
import * as eventsConstructor from 'core/utils/eventsConstructor'
import router from 'app/routes'
import dayjs from 'dayjs'
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

const isProduction = process.env.NODE_ENV === 'production'
EventAgent.mode = isProduction ? 'production' : 'staging'

const state = {
  installmentBumpsAdded: []
}

const getters = {}

const actions = {
  async [types.SEND_EVENT_TO_DATAHUB] (
    { dispatch },
    { system, entity, action, dataVersion = '1.0', payload }
  ) {
    await EventAgent.send({
      system,
      entity,
      action,
      data_version: dataVersion,
      event: payload
    })
  },
  [types.SEND_PUBLISHED_COMPONENTS_EVENT_TO_DATAHUB] (
    { dispatch, rootState: { auth } },
    { activeType, checkoutId, checkoutData }
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    checkoutData.payloadList.forEach((payload, index) => {
      let typeString = ''
      if (index === 0) {
        typeString = `${activeType}_desktop`
      } else {
        typeString = `${activeType}_mobile`
      }

      dispatch(types.SEND_EVENT_TO_DATAHUB, {
        system: 'checkout_builder',
        entity: 'components_published',
        action: 'publish',
        payload: eventsConstructor.componentsPublishedEventBody({
          producerId: Number.parseInt(user.id),
          productId: Number.parseInt(productId),
          type: typeString,
          templatePayload: payload.payload
        })
      })
    })
  },
  [types.SEND_SAVE_BUILDER_WITHOUT_MOBILE] ({ dispatch, rootState: { auth } }) {
    const { user } = auth
    const { productId } = router.history.current.params

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'save_builder_without_mobile',
      action: 'save',
      payload: eventsConstructor.saveBuilderWithoutMobileEventBody({
        producerId: Number.parseInt(user.id),
        productId: Number.parseInt(productId)
      })
    })
  },
  [types.SEND_DROPOFF_BUILDER_CONFIG] (
    { dispatch, rootState: { auth } },
    { type, lastComponentEdited }
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'drop_off_builder_config',
      action: 'leave',
      payload: eventsConstructor.dropOffConfigEventBody({
        producerId: Number.parseInt(user.id),
        productId: Number.parseInt(productId),
        type,
        lastComponent: lastComponentEdited
      })
    })
  },
  [types.SEND_CHANGE_PRODUCT] (
    { dispatch, rootState: { auth } },
    { newProductId, oldProductId }
  ) {
    const { user } = auth

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'change_product',
      action: 'use',
      payload: eventsConstructor.changeProductEventBody({
        producerId: Number.parseInt(user.id),
        newProductId: Number.parseInt(newProductId),
        oldProductId: Number.parseInt(oldProductId)
      })
    })
  },
  [types.SEND_SAVE_CHECKOUT] (
    { dispatch, rootState: { auth } },
    { currentCheckout }
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    const currentCheckoutId = Number.parseInt(currentCheckout)

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'save_checkout',
      action: 'save',
      payload: eventsConstructor.saveCheckoutEventBody({
        producerId: Number.parseInt(user.id),
        productId: Number.parseInt(productId),
        checkoutId: currentCheckoutId
      })
    })
  },
  [types.SEND_PAGEVIEW_DASHBOARD] ({ dispatch, rootState: { auth } }) {
    const { user } = auth
    const { productId } = router.history.current.params

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'pageview_dashboard',
      action: 'view',
      payload: eventsConstructor.basicInfoEventBody({
        producerId: Number.parseInt(user.id),
        productId: Number.parseInt(productId)
      })
    })
  },
  [types.SEND_PAGEVIEW_BUILDER] ({ dispatch, rootState: { auth } }) {
    const { user } = auth
    const { productId } = router.history.current.params

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'pageview_builder',
      action: 'view',
      payload: eventsConstructor.basicInfoEventBody({
        producerId: Number.parseInt(user.id),
        productId: Number.parseInt(productId)
      })
    })
  },
  [types.SEND_EDITED_PLATFORM_CHANGE] (
    { dispatch, rootState: { auth } },
    { newPlatform }
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    const payload = {
      sessionData: {
        ...eventsConstructor.basicInfoEventBody({
          producerId: Number.parseInt(user.id),
          productId: Number.parseInt(productId)
        })
      },
      newPlatform
    }
    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'platform_being_edited',
      action: 'change',
      payload
    })
  },
  [types.SEND_COPY_CHECKOUT_LINK] (
    { dispatch, rootState: { auth } },
    { publicationType, actionOrigin }
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    const payload = {
      producerId: Number.parseInt(user.id),
      productId: Number.parseInt(productId),
      publicationType,
      actionOrigin
    }

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'checkout_link',
      action: 'copy',
      payload
    })
  },
  [types.SEND_USE_DUPLICATE_CHECKOUT] (
    { dispatch, rootState: { auth } },
    { numberOfProductsForDuplication }
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    const payload = {
      producerId: Number.parseInt(user.id),
      productId: Number.parseInt(productId),
      numberOfProductsForDuplication
    }

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'duplicate_checkout',
      action: 'use',
      payload
    })
  },
  [types.SEND_USE_PREVIEW_AND_PUBLISH] ({
    dispatch,
    rootState: { auth, builder }
  }) {
    const { user } = auth
    const { productId } = router.history.current.params

    const payload = {
      producerId: Number.parseInt(user.id),
      productId: Number.parseInt(productId),
      previewWasOpen: builder.previewWasOpen
    }

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'preview_and_publish',
      action: 'use',
      payload
    })
  },
  [types.SEND_VIEW_SUCCESSFUL_PUBLISH_MODAL] (
    { dispatch, rootState: { auth } },
    publicationType
  ) {
    const { user } = auth
    const { productId } = router.history.current.params

    const payload = {
      producerId: Number.parseInt(user.id),
      productId: Number.parseInt(productId),
      publicationType
    }

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'successful_publish_modal',
      action: 'view',
      payload
    })
  },
  [types.SEND_SAVE_ORDER_BUMP] ({ dispatch, state, rootState: { auth } }) {
    const { user } = auth
    const { productId } = router.history.current.params
    const bumps = state.installmentBumpsAdded.map(bump => ({
      bumpCurrency: bump.currencyCode,
      bumpPaymentMode: bump.paymentMode,
      bumpProductId: bump.id,
      bumpOffer: bump.key,
      bumpCreationDate: new Date().getTime(),
      bumpPrice: bump.price
    }))

    const payload = {
      producerId: Number.parseInt(user.id),
      productId: Number.parseInt(productId)
    }

    bumps.forEach(bump => {
      dispatch(types.SEND_EVENT_TO_DATAHUB, {
        system: 'checkout_builder',
        entity: 'order_bump',
        action: 'save',
        payload: {
          ...payload,
          ...bump
        }
      })
    })
  },
  [types.SEND_REDIRECT_CONFIGURATIONS] ({ dispatch, rootState: { auth } }) {
    const { user, currentProduct } = auth
    const currentProductId = Number.parseInt(currentProduct)

    const payload = {
      producerId: Number.parseInt(user.id),
      productId: currentProductId
    }

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'checkout_builder',
      entity: 'redirect_configurations',
      action: 'redirect',
      payload
    })
  },
  [types.SEND_EXIT_POPUP_RECOVERY_TOOL_ACTIVATION] ({
    dispatch,
    rootState: { auth }
  }, editMode) {
    const { user } = auth
    const { productId } = router.history.current.params

    const payload = {
      creatorId: Number.parseInt(user.id),
      productId: Number.parseInt(productId),
      tool: 'exit_popup',
      dateActivation: dayjs().utc().format('DD/MM/YYYY HH:mm:ss')
    }

    dispatch(types.SEND_EVENT_TO_DATAHUB, {
      system: 'app_custom_checkout',
      entity: 'recovery_hub',
      action: editMode ? 'update' : 'activate',
      payload
    })
  }
}

const mutations = {
  [types.SET_INSTALLMENT_BUMPS_ADDED] (state, installmentBumpsAdded) {
    state.installmentBumpsAdded = installmentBumpsAdded
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
